:host {
  --omk-animation-viewbox: 50 0 512 600;
  --omk-animation-preserve-aspect-ratio: xMaxYMid slice;
  --omk-animation-canvas-height: 92px;
  --omk-animation-canvas-width: 328px;
}
